// import { Pipe, PipeTransform, inject } from '@angular/core';
// import { TranslocoService } from '@jsverse/transloco';

// export enum ApplicationStatuses {
//   Applied = 1,
//   ApplicationRejected = 2,
//   Shortlisted = 3,
//   InterviewScheduled = 4,
//   AwaitingCustomerApproval = 5,
//   JobOffered = 6,
//   OfferRejected = 7,
//   OfferAccepted = 8,
//   Hired = 9,
//   Onboarding = 10,
//   InflatedContract = 11,
//   PaymentCompleted = 12,
//   VisaIssued = 13,
//   QVCAppointmentCompleted = 14,
//   QvcCheckPassed = 15,
//   FlightTicketBooked = 16,
//   Placed = 17,
//   Returned = 18,
//   OnBoarded = 19
// }

// @Pipe({
//   name: 'applicationStatus',
//   standalone: true,
//   pure: false
// })
// export class ApplicationStatusPipe implements PipeTransform {
//   private transloco = inject(TranslocoService);

//   transform(value: number): { text: string; color: string; textColor?: string } {
//     const lang = this.transloco.getActiveLang() as 'en' | 'ar';

//     const defaultTextColor = '#ffffff';

//     const statusMap: Record<number, { en: string; ar: string; color: string; textColor?: string }> = {
//       [ApplicationStatuses.Applied]: { en: 'Applied', ar: 'تم التقديم', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.ApplicationRejected]: { en: 'Application Rejected', ar: 'تم رفض الطلب', color: '#EA4F49', textColor: defaultTextColor },
//       [ApplicationStatuses.Shortlisted]: { en: 'Shortlisted', ar: 'تم التصفية', color: '#4763B0', textColor: defaultTextColor },
//       [ApplicationStatuses.InterviewScheduled]: { en: 'Requested for Interview', ar: 'تم تحديد مقابلة', color: '#4763B0', textColor: defaultTextColor },
//       [ApplicationStatuses.AwaitingCustomerApproval]: { en: 'Awaiting Customer Approval', ar: 'في انتظار موافقة العميل', color: '#FFDA74', textColor: '#000000' },
//       [ApplicationStatuses.JobOffered]: { en: 'Job Offered', ar: 'تم عرض الوظيفة', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.OfferRejected]: { en: 'Offer Rejected', ar: 'تم رفض العرض', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.OfferAccepted]: { en: 'Offer Accepted', ar: 'تم قبول العرض', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.Hired]: { en: 'Hired', ar: 'تم التوظيف', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.Onboarding]: { en: 'Onboarding', ar: 'الالتحاق', color: '#5EA38B', textColor: defaultTextColor },
//       [ApplicationStatuses.InflatedContract]: { en: 'Inflated Contract', ar: 'عقد مضخم', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.PaymentCompleted]: { en: 'Payment Completed', ar: 'تم الدفع', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.VisaIssued]: { en: 'Visa Issued', ar: 'تم إصدار التأشيرة', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.QVCAppointmentCompleted]: { en: 'QVC Appointment Completed', ar: 'تم الانتهاء من موعد QVC', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.QvcCheckPassed]: { en: 'QVC Check Passed', ar: 'تم اجتياز فحص QVC', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.FlightTicketBooked]: { en: 'Flight Ticket Booked', ar: 'تم حجز تذكرة الطيران', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.Placed]: { en: 'Placed', ar: 'تم التوظيف', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.Returned]: { en: 'Returned', ar: 'تمت الإعادة', color: '#129B82', textColor: defaultTextColor },
//       [ApplicationStatuses.OnBoarded]: { en: 'On Boarded', ar: 'تم الالتحاق', color: '#129B82', textColor: defaultTextColor }
//     };

//     const status = statusMap[value];
//     return status
//       ? {
//           text: status[lang] ?? status['en'],
//           color: status.color,
//           textColor: status.textColor
//         }
//       : {
//           text: lang === 'ar' ? 'حالة غير معروفة' : 'Unknown Status',
//           color: '#999',
//           textColor: defaultTextColor
//         };
//   }
// }
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export enum ApplicationStatuses {
  NotApplicable = 0,
  Applied = 1,
  ApplicationRejected = 2,
  Onhold = 3,
  InterviewRequested = 4,
  InterviewConfirmed = 5,
  Shortlisted = 6,
  OfferSent = 7,
  OfferRejected = 8,
  OfferAccepted = 9,
  InfialtedContract = 10,
  ContractAcceptedByCustomer = 11,
  ContractRejectedByCustomer = 12,
  ContractRFPByCustomer = 13,
  ContractAcceptedByWorker = 14,
  ContractRejectedByWorker = 15,
  ContractRFPByWorker = 16,
  PaymentIntiated = 17,
  PaymentCompleted = 18,
  PaymentRejected = 19,
  VisaIntiated = 20,
  VisaIssued = 21,
  VisaRejected = 22,
  VisaRequestForCorrection = 23,
  QVCAppointmentInitiated = 24,
  QVCAppointmentRejected = 25,
  QVCAppointmentRequestForCorrection = 26,
  QVCAppointmentCompleted = 27,
  QvcCheckPassed = 28,
  HeathCheckIntiated = 29,
  HeathCheckCompleted = 30,
  HeathCheckRejected = 31,
  HeathCheckRequestForCorrection = 32,
  FlightTicketIntiated = 33,
  FlightTicketBooked = 34,
  ChangeEmployerIntiated = 35,
  ChangeEmployerRejetced = 36,
  ChangeEmployerRequestForCorrection = 37,
  ChangeEmployerCompleted = 38,
  JoiningDateRequested = 39,
  JoiningDateConfirmed = 40,
  JoiningDateRequestForCorrection = 41,
  Placed = 42,
  Returned = 43,
  Cancelled = 44
}

@Pipe({
  name: 'applicationStatus',
  standalone: true,
  pure: false
})
export class ApplicationStatusPipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  transform(value: number): { text: string; color: string; textColor?: string } {
    const lang = this.transloco.getActiveLang() as 'en' | 'ar';
    const defaultTextColor = '#ffffff';

    const statusMap: Record<number, { en: string; ar: string; color: string; textColor?: string }> = {
      [ApplicationStatuses.Applied]: { en: 'Awaiting Customer Approval', ar: 'في انتظار موافقة العميل', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.ApplicationRejected]: { en: 'Request Rejected', ar: 'تم رفض الطلب', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.Onhold]: { en: 'Application On Hold', ar: 'طلب قيد الانتظار', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.InterviewRequested]: { en: 'Requested for Interview', ar: 'طلب تحديد مقابلة', color: '#4763B0', textColor: defaultTextColor },
      [ApplicationStatuses.InterviewConfirmed]: { en: 'Scheduled Interview', ar: 'تم جدولة المقابلة', color: '#4763B0', textColor: defaultTextColor },
      [ApplicationStatuses.Shortlisted]: { en: 'Shortlisted Candidate', ar: 'مرشح مصفى', color: '#4763B0', textColor: defaultTextColor },
      [ApplicationStatuses.InfialtedContract]: { en: 'Contract Initiated', ar: 'تم بدء العقد', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.ContractAcceptedByCustomer]: { en: 'Customer Accepted Contract', ar: 'العميل قبل العقد', color: '#129B82', textColor: defaultTextColor },
      [ApplicationStatuses.ContractRejectedByCustomer]: { en: 'Customer Rejected Contract', ar: 'العميل رفض العقد', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.ContractRFPByCustomer]: { en: 'Contract Requested For Correction By Customer', ar: 'طلب العميل تصحيح العقد', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.ContractAcceptedByWorker]: { en: 'Worker Accepted Contract', ar: 'الموظف قبل العقد', color: '#129B82', textColor: defaultTextColor },
      [ApplicationStatuses.ContractRejectedByWorker]: { en: 'Worker Rejected Contract', ar: 'الموظف رفض العقد', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.ContractRFPByWorker]: { en: 'Contract Requested For Correction By Worker', ar: 'طلب الموظف تصحيح العقد', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.PaymentIntiated]: { en: 'Payment Initiated', ar: 'بدأ الدفع', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.PaymentCompleted]: { en: 'Payment Completed', ar: 'تم الدفع', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.PaymentRejected]: { en: 'Payment Rejected', ar: 'تم رفض الدفع', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.VisaIntiated]: { en: 'Visa Initiated', ar: 'تم بدء التأشيرة', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.VisaIssued]: { en: 'Visa Issued', ar: 'تم إصدار التأشيرة', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.VisaRejected]: { en: 'Visa Rejected', ar: 'تم رفض التأشيرة', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.VisaRequestForCorrection]: { en: 'Visa Request For Correction', ar: 'طلب تصحيح التأشيرة', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.QVCAppointmentInitiated]: { en: 'QVC Initiated', ar: 'تم بدء QVC', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.QVCAppointmentRejected]: { en: 'QVC Rejected', ar: 'تم رفض QVC', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.QVCAppointmentRequestForCorrection]: { en: 'QVC Request For Correction', ar: 'طلب تصحيح QVC', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.QVCAppointmentCompleted]: { en: 'Visa Completed', ar: 'تم الانتهاء من التأشيرة', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.QvcCheckPassed]: { en: 'QVC Passed', ar: 'تم اجتياز QVC', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.HeathCheckIntiated]: { en: 'Health Check Initiated', ar: 'بدء الفحص الصحي', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.HeathCheckCompleted]: { en: 'Health Check Completed', ar: 'انتهى الفحص الصحي', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.HeathCheckRejected]: { en: 'Health Check Rejected', ar: 'تم رفض الفحص الصحي', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.HeathCheckRequestForCorrection]: { en: 'Health Check Request For Correction', ar: 'طلب تصحيح الفحص الصحي', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.FlightTicketIntiated]: { en: 'Flight Ticket Initiated', ar: 'تم بدء حجز تذكرة الطيران', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.FlightTicketBooked]: { en: 'Flight Ticket Booked', ar: 'تم حجز تذكرة الطيران', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.ChangeEmployerIntiated]: { en: 'Change Employer Initiated', ar: 'بدء تغيير صاحب العمل', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.ChangeEmployerRejetced]: { en: 'Change Employer Rejected', ar: 'تم رفض تغيير صاحب العمل', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.ChangeEmployerRequestForCorrection]: { en: 'Change Employer Request For Correction', ar: 'طلب تصحيح تغيير صاحب العمل', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.ChangeEmployerCompleted]: { en: 'Change Employer Completed', ar: 'اكتمل تغيير صاحب العمل', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.JoiningDateRequested]: { en: 'Joining Date Requested', ar: 'طلب تاريخ الانضمام', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.JoiningDateConfirmed]: { en: 'Joining Date Confirmed', ar: 'تم تأكيد تاريخ الانضمام', color: '#5EA38B', textColor: defaultTextColor },
      [ApplicationStatuses.JoiningDateRequestForCorrection]: { en: 'Joining Date Request For Correction', ar: 'طلب تصحيح تاريخ الانضمام', color: '#FFDA74', textColor: '#000000' },
      [ApplicationStatuses.Placed]: { en: 'Placed', ar: 'تم التوظيف', color: '#129B82', textColor: defaultTextColor },
      [ApplicationStatuses.Returned]: { en: 'Application Returned', ar: 'تمت إعادة الطلب', color: '#EA4F49', textColor: defaultTextColor },
      [ApplicationStatuses.Cancelled]: { en: 'Cancelled', ar: 'ألغيت', color: '#999999', textColor: defaultTextColor }
    };

    const status = statusMap[value];
    return status
      ? {
        text: status[lang] ?? status['en'],
        color: status.color,
        textColor: status.textColor
      }
      : {
        text: lang === 'ar' ? 'حالة غير معروفة' : 'Unknown Status',
        color: '#999',
        textColor: defaultTextColor
      };
  }
}

